import { isMyWMApp } from "utils-lib/isMyWMApp"
import { MyWMSwitch } from "./MyWMSwitchContainer"
import AEMSwitch from "./AEMSwitch"

export const Switch = isMyWMApp ? MyWMSwitch : AEMSwitch
